import { LikedPayedProfile, Profile } from "@/types/profile";
import { format, isToday, isYesterday } from "date-fns";
import { differenceInYearsResult } from "./difference-in-years-result";
import i18n from '@/i18n';
import { getLocaleOptions } from "./translations";

export const getSuccessfullVerificationMsg = (name: string | null, gender?: 'male' | 'female'): string => {
    // @ts-ignore
    name ??= i18n.t('user');

    if (gender === 'male') {
        // @ts-ignore
        return i18n.t('user_pass_verification', { context: gender, name });
    }

    if (gender === 'female') {
        // @ts-ignore
        return i18n.t('user_pass_verification', { context: gender, name });
    }

    // @ts-ignore
    return i18n.t('msgs.verification_done');
}

export const getUnPayLikeTitleMsg = (
    myGender: 'male' | 'female' | undefined,
    otherGender: 'male' | 'female' | null
): string => {    
    if (!myGender) return '';
    if (!otherGender) return '';
    // @ts-ignore
    return i18n.t('unpay_like_title', { context: `${otherGender}_to_${myGender}` })
}

export const getDisplayLikeCreatedDate = (date: string): string => {
    if (isToday(date)) {
        // @ts-ignore
        return i18n.t('today_at', { time: format(date, 'HH:mm', getLocaleOptions()) });
    }

    if (isYesterday(date)) {
        // @ts-ignore
        return i18n.t('yesterday_at', { time: format(date, 'HH:mm', getLocaleOptions()) })
    }

    // @ts-ignore
    return format(date, `d MMMM '${i18n.t('at')}' HH:mm`, getLocaleOptions());
};

export const getProfileNameAndAge = (user?: Profile | LikedPayedProfile | null): string => {
    const name = user?.public_name ?? '';
    const age = differenceInYearsResult(user?.dob);

    return name && age ? `${name}, ${age}` : name;
};

export const localizeDate = (rawDate: string | null) => {
    let date = new Date()
    if (rawDate) date = new Date(rawDate)
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    };
    return new Intl.DateTimeFormat(i18n.language, options).format(date)
}

export const localizeMonth = (date: Date) => {
    const options: Intl.DateTimeFormatOptions = { month: 'long' };
    return new Intl.DateTimeFormat(i18n.language, options).format(date)
}

export const localizeMonthYear = (date: Date) => {
    let options: Intl.DateTimeFormatOptions = {
        month: 'long',
        year: 'numeric'
    };
    return new Intl.DateTimeFormat(i18n.language, options).format(date)
}
